import { EndOfJourneyScanCreateResponse } from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// Registers uploaded PDFs (one questionnaire each): the backend reads them in the background, or
// keeps them waiting while the reading is paused
export function createEndOfJourneyScans(input: { uploadIds: string[] }) {
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-scans'].create.url, null))
    .post<EndOfJourneyScanCreateResponse>(input)
}
